<template>
  <div class="exam-footer">
    <button
      v-if="
        currentStep === steps.PRACTICE ||
          (currentStep === steps.REVIEW && !thereIsPracticalPart)
      "
      @click="$emit('go-to-step', steps.QUESTIONS)"
      class="btn btn--secondary btn btn--secondary--with-icon btn btn--secondary--with-icon--left exam-footer__questions__btn"
    >
      <ArrowLeftIcon />
      Questions
    </button>
    <button
      v-if="currentStep !== steps.PRACTICE && thereIsPracticalPart"
      @click="goToPracticeAndSave"
      class="btn btn--primary--with-icon exam-footer__practice__btn"
      :class="[
        lastQuestion && currentStep !== steps.REVIEW
          ? 'btn btn--primary btn--default-icon-color'
          : 'btn btn--secondary btn--default-icon-color',
        currentStep === steps.REVIEW
          ? 'btn btn--primary--with-icon--left exam-footer__practice__btn--left btn--default-icon-color'
          : 'btn btn--primary--with-icon--right exam-footer__practice__btn--right btn--default-icon-color',
      ]"
      :disabled="!canGoToPractice"
    >
      <ArrowLeftIcon v-if="currentStep === steps.REVIEW" />
      Hands-on Lab
      <ArrowRightIcon v-if="currentStep === steps.QUESTIONS" />
    </button>
    <button
      v-if="
        currentStep === steps.PRACTICE ||
          (currentStep === steps.QUESTIONS && !thereIsPracticalPart)
      "
      @click="goToReviewAndSave"
      class="exam-footer__review__btn"
      :class="
        reviewButtonPrimary
          ? 'btn btn--primary btn--default-icon-color'
          : 'btn btn--secondary btn--default-icon-color'
      "
      :disabled="!canGoToReview"
    >
      Review Exam
      <ArrowRightIcon />
    </button>
    <button
      v-if="currentStep === steps.REVIEW"
      @click="$emit('submit')"
      class="btn btn--primary btn--primary--with-icon btn btn--primary--with-icon--right exam-footer__submit__btn"
    >
      Submit Exam
      <ArrowRightIcon />
    </button>
    <StepProgress :steps="steptForStepper" :active="currentStepIndex" />
  </div>
</template>
<script>
import { ArrowLeftIcon, ArrowRightIcon } from 'vue-feather-icons'
import StepProgress from '@/components/shared/StepProgress.vue'

export default {
  name: 'ExamFooter',
  components: {
    ArrowLeftIcon,
    ArrowRightIcon,
    StepProgress,
  },
  props: {
    currentStep: {
      type: String,
      required: true,
    },
    steps: {
      type: Object,
      required: true,
    },
    lastQuestionPosition: {
      type: Boolean,
      required: true,
    },
    canGoToReview: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
    canGoToPractice: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      },
    },
  },
  computed: {
    lastQuestion() {
      return this.lastQuestionPosition
    },
    thereIsPracticalPart() {
      return !!this.steps.PRACTICE
    },
    steptForStepper() {
      return Object.values(this.steps)
    },
    currentStepIndex() {
      return this.steptForStepper.indexOf(this.currentStep)
    },
    reviewButtonPrimary() {
      if (!this.steps.PRACTICE) {
        return this.lastQuestionPosition
      }
      return this.canGoToReview
    },
  },
  methods: {
    goToPracticeAndSave() {
      if (this.currentStep === this.steps.QUESTIONS) {
        this.$emit('save-answers-and-practice')
      } else {
        this.$emit('go-to-step', this.steps.PRACTICE)
      }
    },
    goToReviewAndSave() {
      if (!this.steps.PRACTICE) {
        this.$emit('save-answers-and-review')
      } else {
        this.$emit('go-to-step', this.steps.REVIEW)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.exam-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 30px;
  margin: 15px;
  background: var(--dark-brighter);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  &:before {
    content: '';
    position: absolute;
    background: linear-gradient(
      104.99deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    );
    border-radius: 20px;
    width: 100%;
    height: 90px;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
    display: block;
  }
  &__questions__btn {
    align-self: flex-start;
  }
  &__practice__btn {
    &--right {
      margin-left: auto;
    }
  }
  &__review__btn {
    margin-left: auto;
  }
  &__submit__btn {
    margin-left: auto;
  }
}
</style>
